import React from "react";

const InfoCard = ({ imagen, title, bckGndClr }) => {
  return (
    <div
      className="row w-100 infoCard d-flex align-items-center"
      style={{
        height: "80px",
      }}
    >
      <div
        className="col-3 d-flex justify-content-center align-items-center p-0 m-2"
        style={{
          backgroundColor: bckGndClr,
          borderRadius: "10px",
          height: "80%",
          aspectRatio: "1 / 1",   // 👈 makes it square
        }}
      >
        <img
          src={imagen}
          alt={title}
          style={{
            maxWidth: "60%",
            maxHeight: "60%",
            objectFit: "contain",
          }}
        />
      </div>

      <div className="col-8">
        <div className="fw-bold">
          {title}
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
